import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { map, Observable } from 'rxjs';

import FeatureToggleService from '#services/featureToggle/featureToggle.service';

export const lineOfBusinessToggleGuard = (route: ActivatedRouteSnapshot): Observable<boolean> => {
  const featureToggleService = inject(FeatureToggleService);
  const router = inject(Router);

  return toObservable(featureToggleService.getFeatureToggleSignal('lob')).pipe(
    map((enabled) => {
      const enableRedirect = !enabled;
      const nextUrl = enableRedirect ? `/tci/${route.url.join('/')}` : '';

      if (!route.url.length && nextUrl === '') {
        return true;
      }
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      router.navigate([nextUrl], { queryParams: route.queryParams });
      return false;
    }),
  );
};
